import React, { useEffect, useState } from "react"
import Table from "react-bootstrap/Table"
import "../App.css"

import Departure from "./Departure"
import Stop from "./Stop"

export default function Departures(props: { stopId: string }) {
  const [departures, setDepartures] = useState<Array<any>>([])

  const apiHost = "v6.bvg.transport.rest"

  useEffect(() => {
    const fetchData = async () => {
      const response = await fetch(
        `https://${apiHost}/stops/${props.stopId}/departures?results=6&duration=60`,
      )
      const json = await response.json()

      setDepartures(json.departures)
      console.log("Fetched departures , ", json.departures)
    }

    fetchData().catch(console.error)
  }, [])

  return (
    <div>
      {departures.length > 0 && <Stop name={departures[0].stop.name} />}
      <Table striped hover>
        <tbody>
          {departures.map((departure) => (
            <Departure
              key={departure.tripId}
              direction={departure.direction}
              line={departure.line.id}
              when={new Date(departure.when)}
            />
          ))}
        </tbody>
      </Table>
    </div>
  )
}
